import React from 'react';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface StreamingMarkdownProps {
  text: string;
  isStreaming: boolean;
}

const StreamingMarkdown: React.FC<StreamingMarkdownProps> = ({ text, isStreaming }) => {
  return (
    <div className="agent-markdown text-xs leading-relaxed text-[var(--color-text-primary)]">
      <Markdown remarkPlugins={[remarkGfm]}>{text}</Markdown>
      {isStreaming && (
        <span className="inline-block w-0.5 h-3.5 bg-[var(--color-text-muted)] animate-pulse ml-0.5 align-text-bottom" />
      )}
    </div>
  );
};

export default StreamingMarkdown;
